import { FormControl, FormHelperText, TextField } from "@mui/material";
import { useField } from "formik";
import useAuth from "hooks/useAuth";

const IndieNumberField = ({ label, permissionGroups, useAuthTests, disallowNegative = false, integersOnly = false, customStep = "any", ...props }) => {
    const [field, meta, helpers] = useField(props);

    const auth = useAuthTests || useAuth;
    const { hasPermissionGroup } = auth();

    if (permissionGroups && !hasPermissionGroup(permissionGroups)) {
        return "";
    }

    return (
        <FormControl>
            <TextField
                {...field}
                {...props}
                label={label}
                type="number"
                value={field.value ? field.value : (props.value || "")}
                onChange={(e) => {
                    let value = e.target.value;
                    
                    // Handle integersOnly restriction
                    if (integersOnly && value.includes('.')) {
                        value = value.replace('.', '');
                    }
                    
                    // Handle disallowNegative restriction
                    if (disallowNegative && value.includes('-')) {
                        value = value.replace('-', '');
                    }
                    
                    if (props.onChange) {
                        helpers.setValue(value);
                        const modifiedEvent = { ...e, target: { ...e.target, value } };
                        props.onChange(modifiedEvent);
                    } else {
                        helpers.setValue(value);
                    }
                }}
                error={meta.touched && meta.error ? true : false}
                variant="standard"
                InputProps={{
                    inputProps: {
                        step: customStep, // Allows any number input without fixed increments
                        onWheel: (e) => e.target.blur(), // Prevents changing value on scroll
                        onKeyDown: (e) => {
                            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                e.preventDefault(); // Disables the arrow key behavior
                            }
                            
                            // Prevent decimal point input for integers only
                            if (integersOnly && (e.key === '.' || e.key === ',')) {
                                e.preventDefault();
                            }
                            
                            // Prevent minus sign input when negative numbers are disallowed
                            if (disallowNegative && (e.key === '-' || e.key === 'Minus')) {
                                e.preventDefault();
                            }
                        }
                    },
                    ...props.InputProps
                }}
                
            />
            {meta.error ? (
                <FormHelperText id={`form_error_text_${props.name}`} error sx={{ ml: 0, pl: 0 }}>{meta.error}</FormHelperText>
            ) : null}
        </FormControl>
    );
}

export default IndieNumberField;